<template>
  <div>
    <CrudList
      title="Ciudades"
      storeName="Cities"
      parentStoreName="Provinces"
      parentUrlKey="province_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
      canSearch
      sortable
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/provinces'
        },
        {
          text: 'Ciudades',
          disabled: false,
          href: '#'
        }
      ]"
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
